var _title, _desc, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgLegal = function SvgLegal(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "script [#1601]")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7,10 L13,10 L13,8 L7,8 L7,10 Z M7,6 L13,6 L13,4 L7,4 L7,6 Z M16,4 L16,2 C17.103,2 18,2.898 18,4 L16,4 Z M14,16 C14,17.103 13.103,18 12,18 L12,14 L6,14 L6,4 C6,2.898 6.897,2 8,2 L14,2 L14,16 Z M10,18 L4,18 C2.897,18 2,17.103 2,16 L10,16 L10,18 Z M16,0 L8,0 C5.791,0 4,1.791 4,4 L4,14 L0,14 L0,16 C0,18.21 1.791,20 4,20 L12,20 C14.209,20 16,18.21 16,16 L16,6 L20,6 L20,4 C20,1.791 18.209,0 16,0 L16,0 Z",
    id: "script-[#1601]",
    fill: "#FFFFFF"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLegal, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/legal.1e174845.svg";
export { ForwardRef as ReactComponent };